
  import {
    PipedriveDealCommand,
    PipedriveOrganizationCommand,
    PipedrivePersonCommand,
    PipedriveComboCommand,
    LicenseMailTemplate,
    UserDto
  } from '@/apiclient/apiclient_generated';
  import { NotificationService } from '@/services/notification-service';
  import { AccountModule, AccountStore } from '@/store/account';
  import { LicenseModule, LicenseStore } from '@/store/license';
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from 'vue-property-decorator';

  @Options({})
  export default class PushToPipedrive extends Vue {
    private accountStore: AccountModule = AccountStore;
    private licenseStore: LicenseModule = LicenseStore;

    @Prop() account;

    mailTemplates = [LicenseMailTemplate.TrialTemplate, LicenseMailTemplate.PurchaseTemplate];

    isLoading = false;

    dealTitle = 'Deal';
    /* firstName = "";
    lastName = "";
    organization = ""; */

    get modalHeader() {
      return 'Push To Pipedrive';
    }

    get firstName() {
      return this.account?.name;
    }

    get lastName() {
      return this.account?.surname;
    }

    get organization() {
      return this.account?.company;
    }

    /* async mounted() {
      console.log(this.account);
      this.firstName = this.account?.name;
      this.lastName = this.account?.surname;
      this.organization = this.account?.company;
    } */

    get isFormValid() {
      return !this.isLoading;
    }

    async submitForm() {
      this.isLoading = true;

      const personCommand = {
        name: this.firstName + ' ' + this.lastName,
        email: this.account.email
      } as PipedrivePersonCommand;

      const organizationCommand = {
        name: this.organization
      } as PipedriveOrganizationCommand;

      const command = {
        pipedriveOrganizationCommand: organizationCommand,
        pipedrivePersonCommand: personCommand
      } as PipedriveComboCommand;

      const result = await this.accountStore.pushToPipedrive(command);

      this.isLoading = false;

      if (result.isSuccess) {
        NotificationService.NotifySuccess('Account succesfully pushed to Pipedrive.');

        window.open('https://presentaid.pipedrive.com/deal/' + result.pipedriveResponse?.id.toString(), '_blank');

        this.$emit('close');
      } else {
        NotificationService.NotifyErrors(result.errors);
      }
    }

    cancelForm() {
      this.$emit('cancel');
    }
  }
